import React from "react"
import type { IntegracaoWhatsappModel } from "../models/integracaoWhatsappModel"
import { IntegracaoWhatsappInicial } from "../models/integracaoWhatsappModel"
import type { IntegracaoWhatsappActions } from "./integracaoWhatsappActions"

interface IntegracaoWhatsappContextValue {
    dados: IntegracaoWhatsappModel
    dispatch: React.Dispatch<IntegracaoWhatsappActions>
    erroCarregamento: string | null
    salvar: () => Promise<void>
    recarregarTemplates: () => Promise<void>
}

export const IntegracaoWhatsappContext = React.createContext<IntegracaoWhatsappContextValue>({
    dados: IntegracaoWhatsappInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    salvar: async () => undefined,
    recarregarTemplates: async () => undefined,
})
